import React from 'react';

const SCREENS = [
  { key: 'dashboard', label: 'Dashboard', description: 'Main overview and metrics' },
  { key: 'customer_management', label: 'Customers', description: 'Customer list and details' },
  { key: 'bid_management', label: 'Bids', description: 'Bid creation and tracking' },
  { key: 'project_management', label: 'Projects', description: 'Project list and status' },
  { key: 'resource_management', label: 'Resources', description: 'Resource allocation and calendar' },
  { key: 'prospect_management', label: 'Prospects', description: 'Lead and prospect tracking' },
  { key: 'analytics', label: 'Analytics & Reporting', description: 'Charts and performance reports' },
  { key: 'project_phases', label: 'Project Phases', description: 'Phase and deliverable management' },
  { key: 'pm_dashboard', label: 'PM Dashboard', description: 'Project manager overview' },
  { key: 'application_bug_tracker', label: 'Bug Tracker', description: 'Internal issue tracking' },
  { key: 'team_administration', label: 'Team Administration', description: 'User and role management' },
  { key: 'audit_log', label: 'Audit Log', description: 'System activity history' }
];

const ScreenVisibilityToggles = ({ visibility, onToggle }) => {
  return (
    <div className="divide-y divide-border">
      {SCREENS?.map((screen) => {
        const isEnabled = visibility?.[screen?.key] !== false;
        return (
          <div key={screen?.key} className="flex items-center justify-between py-3">
            <div className="flex-1 min-w-0 pr-4">
              <p className="text-sm font-medium text-foreground">{screen?.label}</p>
              <p className="text-xs text-muted-foreground">{screen?.description}</p>
            </div>
            <div className="flex items-center gap-3">
              <span className={`text-xs font-medium ${
                isEnabled ? 'text-green-600' : 'text-muted-foreground'
              }`}>
                {isEnabled ? 'Visible' : 'Hidden'}
              </span>
              <button
                type="button"
                onClick={() => onToggle(screen?.key)}
                className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
                  isEnabled ? 'bg-primary' : 'bg-muted-foreground/30'
                }`}
              >
                <span
                  className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                    isEnabled ? 'translate-x-6' : 'translate-x-1'
                  }`}
                />
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ScreenVisibilityToggles;
